import { useMutation } from "@tanstack/react-query";
import { WiMuleSQL } from "../../services/WiMuleSQL";

const deleteFilter = async ({ location, faultInfo }) => {
  const encodedLocation = encodeURIComponent(location);
  const encodedFaultInfo = encodeURIComponent(faultInfo);

  const queryString = `${WiMuleSQL}/api/ActiveFaults/DeleteFilter?location=${encodedLocation}&faultInfo=${encodedFaultInfo}`;
  console.log("DeleteFilterQueried", queryString);

  const response = await fetch(queryString, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    const errorMessage = `HTTP Error: ${response.status} - ${response.statusText}`;
    console.error(errorMessage);
    throw new Error(errorMessage);
  }

  return response.json();
};

export const useDeleteFilter = () => {
  return useMutation({
    mutationFn: deleteFilter,
    onSuccess: (data) => {
      console.log("Delete successful:", data);
    },
    onError: (error) => {
      console.error("Delete failed:", error.message);
    },
  });
};
